import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AraGenericChipComponent } from '@shared/ui/ara-generic-chip/ara-generic-chip.component';

/** Zeitlicher Status eines Rollen-Eintrags relativ zu heute. */
export type RoleHistoryStatus = 'past' | 'today' | 'future';

/** Ein Eintrag im Verlauf-Hover einer Rollenspalte (vergangen, heute gültig oder zukünftig). */
export interface RoleHistoryEntry {
	status: RoleHistoryStatus;
	period: string;
	name: string;
}

/** Verlauf-Hover-Daten einer Rollenspalte: Rollen-Label + chronologische Einträge. */
export interface RoleHistory {
	label: string;
	entries: RoleHistoryEntry[];
}

/** Einheitliches Status-Icon je Zeit-Status (heute/vergangen/zukünftig) — app-weit konsistent. */
export function roleStatusIcon(status: RoleHistoryStatus): string {
	switch (status) {
		case 'today':
			return 'today';
		case 'future':
			return 'schedule';
		default:
			return 'history';
	}
}

/**
 * Präsentations-Panel für den Rollen-Verlauf-Hover (Titel + Zeitraum-Chip + Name je Eintrag).
 * Reine Anzeige — die Daten baut der Aufrufer (Zeiträume/Namen sind bereits übersetzt/formatiert).
 */
@Component({
	selector: 'ara-role-history-popover',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIcon, AraGenericChipComponent],
	templateUrl: './role-history-popover.component.html',
})
export class AraRoleHistoryPopoverComponent {
	readonly history = input.required<RoleHistory>();
	protected readonly statusIcon = roleStatusIcon;
}
